/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_Cancel_StatusInputs */

const cs_deal_payments_cancel_status = /** @type {(inputs: Deal_Payments_Cancel_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit platbu`)
};

const en_deal_payments_cancel_status = /** @type {(inputs: Deal_Payments_Cancel_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel payment`)
};

/**
* | output |
* | --- |
* | "Cancel payment" |
*
* @param {Deal_Payments_Cancel_StatusInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_cancel_status = /** @type {((inputs?: Deal_Payments_Cancel_StatusInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_Cancel_StatusInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_cancel_status(inputs)
	return cs_deal_payments_cancel_status(inputs)
});